import React, { Component } from "react";
import CountDownNow from 'react-countdown-now';

export default class ActivityTime extends Component {
  constructor(props) {
    super(props)
    this.state = {
      timeoutTipDom: null
    }
  }

  _onTimerEnded() {
    // console.log('倒计时结束了:::')
    const {countTimeEnded} = this.props
    countTimeEnded({isStop: true})
  }

  render() {
    const renderTimer = ({ hours, minutes, seconds, completed }) => {
      if (!completed) {
        return <span className='timer'>{hours}:{minutes}:{seconds}</span>
      } else {
        // this.forceUpdate()
        return <span className='timer'>{hours}:{minutes}:{seconds}</span>
      }
    }
    let { timerObj, statusBtnDom, curStatus, timeInfo } = this.props
    console.log('props_timeInfo.len:::', timeInfo)
    let timeoutTipDom = null
    if (curStatus !== 'noNext') {
      timeoutTipDom = (
        <div className="timeoutTip">
          <div className="timerWrap">
            {timerObj.name} <CountDownNow date={timerObj.calcTime} renderer={renderTimer} onComplete={this._onTimerEnded.bind(this)} daysInHours={true}/>
          </div>
          {statusBtnDom}
        </div>
      )
    }
    console.log('timer.calcTime:::', timerObj.calcTime, statusBtnDom)
    // <span>每天{timeInfo.timeSlots.length}场</span>
    return (
      <div className="timesWrap">
        <p className="scene">
          {timeInfo.dateRangeTip}
        </p>
        <ul className="regions">
          {
            timeInfo.timeSlots.map((item, index) => {
              return (
                timeInfo.timeSlots.length <=2 ? (
                  <li className='twoItem' key={index}>{item}</li>
                ) : (
                  <li className='otherItem' key={index}>{item}</li>
                )
              )
            })
          }
        </ul>
        {timeoutTipDom}
      </div>
    )
  }
}